import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Membership from './pages/Membership';
import MemberServices from './pages/MemberServices';
import VerifyMember from './pages/VerifyMember';
import VerifyCertificate from './pages/VerifyCertificate';
import Downloads from './pages/Downloads';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Registration from './pages/Registration';
import ResetPasswordGuard from './components/ResetPasswordGuard';
import { AuthProvider } from './Members-portal/utils/AuthContext';
import { ThemeProvider } from './Members-portal/utils/ThemeContext';
import { MembersLayout, Dashboard, Profile, MyProfile } from './Members-portal';
import ProtectedRoute from './Members-portal/components/ProtectedRoute';
import Notifications from './Members-portal/pages/Notifications';
import Messages from './Members-portal/pages/Messages';
import Documents from './Members-portal/pages/Documents';
import './App.css';

// ScrollToTop component to handle automatic scrolling on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App min-h-screen flex flex-col">
          <ScrollToTop />

          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Home />
                </main>
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Header />
                <main className="flex-grow">
                  <About />
                </main>
                <Footer />
              </>
            } />
            <Route path="/membership" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Membership />
                </main>
                <Footer />
              </>
            } />
            <Route path="/member-services" element={
              <>
                <Header />
                <main className="flex-grow">
                  <MemberServices />
                </main>
                <Footer />
              </>
            } />
            <Route path="/verify-member" element={
              <>
                <Header />
                <main className="flex-grow">
                  <VerifyMember />
                </main>
                <Footer />
              </>
            } />
            <Route path="/verify-certificate" element={
              <>
                <Header />
                <main className="flex-grow">
                  <VerifyCertificate />
                </main>
                <Footer />
              </>
            } />
            <Route path="/downloads" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Downloads />
                </main>
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Contact />
                </main>
                <Footer />
              </>
            } />
            <Route path="/login" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Login />
                </main>
                <Footer />
              </>
            } />
            <Route path="/register" element={
              <>
                <Header />
                <main className="flex-grow">
                  <Registration />
                </main>
                <Footer />
              </>
            } />
            <Route path="/reset-password" element={
              <>
                <Header />
                <main className="flex-grow">
                  <ResetPasswordGuard />
                </main>
                <Footer />
              </>
            } />

            {/* Protected Members Portal Routes */}
            <Route path="/members/*" element={
              <ProtectedRoute>
                <ThemeProvider>
                  <MembersLayout>
                    <Routes>
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="profile" element={<Profile />} />
                      <Route path="company-profile" element={<Profile />} />
                      <Route path="my-profile" element={<MyProfile />} />
                      <Route path="membership" element={<div>Membership Page</div>} />
                      <Route path="documents" element={<Documents />} />
                      <Route path="messages" element={<Messages />} />
                      <Route path="notifications" element={<Notifications />} />
                      <Route path="" element={<Dashboard />} />
                    </Routes>
                  </MembersLayout>
                </ThemeProvider>
              </ProtectedRoute>
            } />
          </Routes>

          <ToastContainer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
